import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    padding: 0.4rem;
    border-radius: 10px;
    background-color: ${({ isUserSystem }) => isUserSystem ? ' #E7F8FF' : '#ffffff'};
    box-shadow: 0 1px 1px #ccc;
    cursor: pointer;
    &:hover{
        filter: brightness(0.94);
    }
    > p{
        padding: 2px;
        font-size: 14px;
        word-break: break-word;
        white-space: pre-wrap; 
        text-align: left;
        margin-right: 30px;
    }
`